import { locale, t } from "../../i18n/i18n";
import { missionName } from "../../i18n/vocabulary";
import type { FootprintResult } from "./footprint";
import { AREA_CAP_KM2, FOOTPRINT_ERRORS, isZoneLevel } from "./footprint";

/** Textes de la zone libre : longueur d'axe (« 32,4 km »), surface (« 3 850 km² »), puce du tracé. */

export function formatLengthKm(metres: number): string {
  return `${(metres / 1000).toLocaleString(locale(), { minimumFractionDigits: 1, maximumFractionDigits: 1 })} km`;
}

export function formatAreaKm2(km2: number): string {
  return `${Math.round(km2).toLocaleString(locale())} km²`;
}

/** Puce qui suit le pointeur pendant le tracé de l'axe : longueur, surface préparée et plafond du niveau ; en cas de
 *  refus, la règle (« Longueur admise : 5 à 200 km », « Zone trop étendue pour ce niveau »). */
export function axisTagText(result: FootprintResult, level: string, mission: string | null): { text: string; refused: boolean } {
  const length = result.ok ? result.footprint.length_m : result.length_m;
  const area = result.ok ? result.footprint.area_km2 : result.area_km2;
  if (!result.ok && (result.error === "level" || result.error === "world" || length === undefined))
    return { text: t(FOOTPRINT_ERRORS[result.error]), refused: true };
  const parts = [formatLengthKm(length!)];
  if (!result.ok) parts.push(t(FOOTPRINT_ERRORS[result.error]));
  else if (area !== undefined && isZoneLevel(level))
    parts.push(t("terrain {area} ({cap} au plus)", { area: formatAreaKm2(area), cap: Math.round(AREA_CAP_KM2[level]).toLocaleString(locale()) }));
  if (result.ok && mission) parts.push(missionName(mission));
  return { text: parts.join(" · "), refused: !result.ok };
}
